import { initializeApp, setLogLevel } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyCAMwBVx5EMHuDJTRA7X3ml_pEc09kcyp0",
  authDomain: "edm-corretores.firebaseapp.com",
  projectId: "edm-corretores",
  storageBucket: "edm-corretores.firebasestorage.app",
  messagingSenderId: "1055780201905",
  appId: "1:1055780201905:web:ec10f12a74b755de7d8990",
  measurementId: "G-3X84E3M458"
};

// Evita spam no console (ex.: Firebase Performance "Tries left") em produção.
if (process.env.NODE_ENV === 'production') {
  setLogLevel('error');
}

const app = initializeApp(firebaseConfig);

/**
 * App Check (reCAPTCHA v3) — chave separada da v2 do login.
 * .env: REACT_APP_APPCHECK_RECAPTCHA_SITE_KEY=...
 * Em localhost: REACT_APP_APPCHECK_DEBUG_TOKEN=true (e registre o token no Console).
 */
const appCheckSiteKey = (process.env.REACT_APP_APPCHECK_RECAPTCHA_SITE_KEY || '').trim();
if (typeof window !== 'undefined') {
  if (process.env.REACT_APP_APPCHECK_DEBUG_TOKEN === 'true') {
    // eslint-disable-next-line no-underscore-dangle
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  if (appCheckSiteKey) {
    try {
      initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(appCheckSiteKey),
        isTokenAutoRefreshEnabled: true,
      });
    } catch (e) {
      // Não bloqueia o app se App Check não estiver configurado no Console ainda
      console.warn('App Check não inicializado:', e?.message || e);
    }
  }
}

export const firebaseMeasurementId = firebaseConfig.measurementId;
export { app };
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
